import { Injectable } from '@angular/core';
import {IdCodeNameModel, IdCodeNameQuery, LeModalService, MesApiService} from "common-shared";
import {map} from "rxjs/operators";
import {plainToClass, plainToInstance, Type} from "class-transformer";
import {SpecLineModel} from "web-shared";
import {ContactEditModalComponent} from "./contact-edit-modal/contact-edit-modal.component";

export class ContactQuery extends IdCodeNameQuery {
  Comment: string;

  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'Comment'];
  }
}

export class ContactModel extends IdCodeNameModel {
  constructor(init?: Partial<ContactModel>) {
    super();
    Object.assign(this, init);
  }
  Comment: string;
  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];

  isValid(): boolean {
    return this.Specs.every(spec => spec.isValid());
  }
}

@Injectable({
  providedIn: 'root'
})
export class ContactService extends MesApiService {

  constructor(private modalService: LeModalService) {
    super('contact');
  }

  getAll(){
    return this.getList<ContactQuery>({action: 'GetAll'})
      .pipe(map(value => plainToInstance(ContactQuery, value.data)));
  }

  loadOne(id: string) {
    return this.getSingle<ContactModel>(id).pipe(map(value => {
      return plainToClass(ContactModel, value.data);
    }));
  }

  addNew(model: ContactModel) {
    return this.add<ContactModel>(model, {
      action: 'Post'
    }).pipe(map(value => {
      return plainToClass(ContactModel, value.data);
    }));
  }

  save(model: ContactModel) {
    return this.update<ContactModel>(model.Id, model).pipe(map(value => {
      return plainToClass(ContactModel, value.data);
    }));
  }

  remove(model: ContactModel) {
    return this.delete<ContactModel>(model.Id).pipe(map(value => {
      return plainToClass(ContactModel, value.data);
    }));
  }

  edit(id: string){
    return this.modalService.show(ContactEditModalComponent, {initialState: {entityId: id} as ContactEditModalComponent, class: "modal-xl"}).content.onHide$;
  }
}
